import React, { useState } from "react";

// FAQs
const FAQs = ({ language }) => {
  // States
  const [activeFaq, setActiveFaq] = useState();

  // FAQs
  const faqs = [
    {
      question_english: "What’s Hero NFT card?",
      question_korean: "히어로 NFT 카드는 무엇인가요?",
      question_chinese: "什么是英雄 NFT 卡?",
      question_vietnamese: "Thẻ Hero NFT là gì?",
      question_arabic: "ما هي بطاقة Hero NFT؟",
      answer_english: `A non-fungible token (NFT) is a virtual token that uses blockchain technology to prove the owner of a digital asset. Addresses pointing to digital files such as pictures and videos are stored in tokens, and are used to indicate their unique originality and ownership. That is, some sort of virtual certificate of authenticity. The Hero NFT card is designed with the concept that not only a specific character can become a hero, but also ordinary people can become a hero.`,
      answer_korean:
        "NFT(Non-Fungible Token)는 블록체인 기술을 사용하여 디지털 자산의 소유자를 증명하는 가상 토큰입니다. 사진 및 동영상과 같은 디지털 파일을 가리키는 주소는 토큰에 저장되며 고유한 독창성과 소유권을 나타내는 데 사용됩니다. 즉, 일종의 가상 정품 인증서입니다. 히어로 NFT 카드는 특정 캐릭터가 히어로가 될 수 있을 뿐만 아니라 일반인도 히어로가 될 수 있다는 컨셉으로 디자인되었습니다.",
      answer_chinese:
        "不可替代代币（NFT）是一种虚拟代币，它使用区块链技术来证明数字资产的所有者。指向图片和视频等数字文件的地址存储在令牌中，用于表明其独特的原创性和所有权。也就是说，某种虚拟的真实性证书。 Hero NFT卡的设计理念是不仅特定角色可以成为英雄，普通人也可以成为英雄。",
      answer_vietnamese:
        "Mã thông báo không thể thay thế (NFT) là mã thông báo ảo sử dụng công nghệ blockchain để chứng minh chủ sở hữu của tài sản kỹ thuật số. Các địa chỉ trỏ đến các tệp kỹ thuật số như hình ảnh và video được lưu trữ trong mã thông báo và được sử dụng để biểu thị tính nguyên bản và quyền sở hữu duy nhất của chúng. Đó là, một số loại chứng chỉ ảo về tính xác thực. Thẻ Hero NFT được thiết kế với quan niệm không chỉ một nhân vật cụ thể mới có thể trở thành anh hùng mà cả những người bình thường cũng có thể trở thành anh hùng.",
      answer_arabic:
        "الرمز غير القابل للاستبدال (NFT) هو رمز افتراضي يستخدم تقنية blockchain لإثبات مالك الأصل الرقمي. يتم تخزين العناوين التي تشير إلى الملفات الرقمية مثل الصور ومقاطع الفيديو في رموز ، وتستخدم للإشارة إلى أصالتها الفريدة وملكيتها. هذا هو نوع من الشهادة الافتراضية للأصالة. تم تصميم بطاقة Hero NFT بمفهوم أنه ليس فقط شخصية معينة يمكن أن تصبح بطلاً ، ولكن أيضًا يمكن للأشخاص العاديين أن يصبحوا بطلاً.",
    },
    {
      question_english: "What's a Whitelist?",
      question_korean: "화이트리스트란 무엇인가요?",
      question_chinese: "什么是白名单？",
      question_vietnamese: "Danh sách trắng là gì?",
      question_arabic: "ما هي القائمة البيضاء؟",
      answer_english: `A whitelist is not just to purchase NFTs from the point of view of a buyer, but to purchase NFTs at a discounted price. And you can get additional services. The BCL Foundation provides level-up benefits to those who purchase Hero NFT cards through the whitelist to increase their mining speed. Those who purchase directly from OpenC or Binance NFT do not have this benefit.`,
      answer_korean:
        "화이트리스트는 단순히 구매자의 관점에서 NFT를 구매하는 것이 아니라 할인된 가격으로 NFT를 구매하는 것입니다. 그리고 추가 서비스를 받을 수 있습니다. BCL 재단은 마이닝 속도를 높이기 위해 화이트리스트를 통해 Hero NFT 카드를 구매하는 사람들에게 레벨업 혜택과 특별 프로모션을 제공합니다. Opensea 또는 Binance NFT에서 직접 구매하는 사람들은 이 혜택이 없습니다.",
      answer_chinese:
        "白名单不仅仅是从买方的角度购买 NFT，而是以折扣价购买 NFT。并且您可以获得额外的服务。 BCL基金会为通过白名单购买Hero NFT卡的人提供升级福利和特别优惠，以提高他们的挖矿速度。直接从 Opensea 或 Binance NFT 购买的人没有此优惠。",
      answer_vietnamese:
        "Danh sách trắng không chỉ để mua NFT theo quan điểm của người mua, mà để mua NFT với giá chiết khấu. Và bạn có thể nhận được các dịch vụ bổ sung. BCL Foundation cung cấp các lợi ích tăng cấp và khuyến mãi đặc biệt cho những người mua thẻ Hero NFT thông qua danh sách trắng để tăng tốc độ khai thác của họ. Những người mua trực tiếp từ Opensea hoặc Binance NFT không có lợi ích này.",
      answer_arabic:
        "القائمة البيضاء ليست فقط لشراء NFT من وجهة نظر المشتري ، ولكن لشراء NFTs بسعر مخفض. ويمكنك الحصول على خدمات إضافية. توفر مؤسسة BCL مزايا رفع المستوى والعروض الترويجية الخاصة لأولئك الذين يشترون بطاقات Hero NFT من خلال القائمة البيضاء لزيادة سرعة التعدين. أولئك الذين يشترون مباشرة من Opensea أو Binance NFT لا يتمتعون بهذه الميزة.",
    },
    {
      question_english: "How many Hero NFT cards is made?",
      question_korean: "히어로 NFT 카드는 몇 장 제작되나요?",
      question_chinese: "制作了多少张 Hero NFT 卡？",
      question_vietnamese: "Có bao nhiêu thẻ Hero NFT được tạo ra?",
      question_arabic: "كم عدد بطاقات Hero NFT المصنوعة؟",
      answer_english: `There will be 10,000 hero cards. This will be sold in 3 parts. The first 1,500 pieces, the second 3,000 pieces, the third 2,500 pieces, and 1,000 pieces will be sold at Opensea through Dutch auction.`,
      answer_korean:
        "영웅 카드는 10,000장입니다. 3부작으로 판매될 예정입니다. 첫 1,500개, 두 번째 3,000개, 세 번째 2,500개, 1,000개는 더치옥션을 통해 Opensea에서 판매됩니다.",
      answer_chinese:
        "将有10,000张英雄卡。这将分 3 部分出售。前1500件、第二件3000件、第三件2500件、1000件将在Opensea通过荷兰拍卖的方式出售。",
      answer_vietnamese:
        "Sẽ có 10.000 thẻ anh hùng. Điều này sẽ được bán trong 3 phần. 1.500 mảnh đầu tiên, 3.000 mảnh thứ hai, 2.500 mảnh thứ ba và 1.000 mảnh sẽ được bán tại Opensea thông qua hình thức đấu giá của Hà Lan.",
      answer_arabic:
        "سيكون هناك 10000 بطاقة بطل. سيباع هذا في 3 أجزاء. سيتم بيع 1500 قطعة الأولى والثانية 3000 قطعة والثالثة 2500 قطعة و 1000 قطعة في Opensea من خلال المزاد الهولندي.",
    },
    {
      question_english: "How much is mintable price?",
      question_korean: "민팅 가능 가격은 얼마입니까?",
      question_chinese: "可铸币价格是多少？",
      question_vietnamese: "Giá có thể đúc được là bao nhiêu?",
      question_arabic: "كم هو السعر القابل للسك؟",
      answer_english:
        "The first mitable price is about $40. It will only be sold in BCL tokens. The 2nd and 3rd rounds are expected to increase in price, and will be sold with various payment methods as well as BCL tokens.",
      answer_korean:
        "첫 번째 마이터블 가격은 약 0.022ETH입니다. BCL, MATIC 및 ETH 토큰으로 판매됩니다. 2차, 3차 가격 인상이 예상된다.",
      answer_chinese:
        "第一个可兑换价格约为 0.022ETH。它将以 BCL、MATIC 和 ETH 代币出售。第二和第三轮预计价格会上涨。",
      answer_vietnamese:
        "Giá phù hợp đầu tiên là khoảng 0,022ETH. Nó sẽ được bán bằng mã thông báo BCL, MATIC và ETH. Đợt 2 và đợt 3 dự kiến ​​sẽ tăng giá.",
      answer_arabic:
        "أول سعر قابل للقش هو حوالي 0.022ETH. سيتم بيعها في رموز BCL و MATIC و ETH. من المتوقع أن يرتفع سعر الجولتين الثانية والثالثة.",
    },
    {
      question_english: "When do you start selling?",
      question_korean: "언제 판매를 시작하는가?",
      question_chinese: "你什么时候开始卖？",
      question_vietnamese: "Khi nào bạn bắt đầu bán hàng?",
      question_arabic: "متى تبدأ البيع؟",
      answer_english: "August 16, 2022.",
      answer_korean: "2022년 8월 16일.",
      answer_chinese: "2022 年 8 月 16 日。",
      answer_vietnamese: "Ngày 16 tháng 8 năm 2022.",
      answer_arabic: "16 أغسطس 2022.",
    },
    {
      question_english: "Where can view my NFT hero cards?",
      question_korean: "내 NFT 영웅 카드는 어디에서 볼 수 있나요?",
      question_chinese: "在哪里可以查看我的 NFT 英雄卡？",
      question_vietnamese: "Có thể xem thẻ anh hùng NFT của tôi ở đâu?",
      question_arabic: "أين يمكنني مشاهدة بطاقات بطل NFT الخاصة بي؟",
      answer_english:
        "Once minted, simply connected to your opensea count to view your NFTs.",
      answer_korean:
        "발행되면 Opensea 카운트에 연결하기만 하면 NFT를 볼 수 있습니다.",
      answer_chinese: "铸造后，只需连接到您的 opensea 计数即可查看您的 NFT。",
      answer_vietnamese:
        "Sau khi được đúc, chỉ cần kết nối với số lượng openea của bạn để xem các NFT của bạn.",
      answer_arabic:
        "بمجرد سكها ، قم ببساطة بالاتصال بـ openea الخاص بك لعرض NFTs.",
    },
  ];

  return (
    <React.Fragment>
      <main className="faqs-page">
        <section className="hero">
          <div className="container">
            <h1>
              <span>\\</span> Frequently Asked Questions <span>//</span>
            </h1>

            <div className="questions-answers">
              {faqs.map((faq, index) => {
                return (
                  <div
                    className={
                      activeFaq === index
                        ? "question-answer active"
                        : "question-answer"
                    }
                    key={index}
                  >
                    <div
                      className="question"
                      onClick={() => {
                        if (activeFaq === index) {
                          setActiveFaq();
                        } else {
                          setActiveFaq(index);
                        }
                      }}
                    >
                      <p>
                        {language === "english"
                          ? faq.question_english
                          : language === "korean"
                          ? faq.question_korean
                          : language === "chinese"
                          ? faq.question_chinese
                          : language === "vietnamese"
                          ? faq.question_vietnamese
                          : language === "arabic"
                          ? faq.question_arabic
                          : null}
                      </p>

                      <svg
                        width="18"
                        height="11"
                        viewBox="0 0 18 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.04908 10.6246L0.396686 3.38359C-0.132229 2.88311 -0.132229 2.07381 0.396686 1.57865L1.66833 0.375363C2.19725 -0.125121 3.05252 -0.125121 3.5758 0.375363L9 5.50799L14.4242 0.375363C14.9531 -0.125121 15.8084 -0.125121 16.3317 0.375363L17.6033 1.57865C18.1322 2.07914 18.1322 2.88843 17.6033 3.38359L9.95092 10.6246C9.43326 11.1251 8.57799 11.1251 8.04908 10.6246Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <div className="answer">
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            language === "english"
                              ? faq.answer_english
                              : language === "korean"
                              ? faq.answer_korean
                              : language === "chinese"
                              ? faq.answer_chinese
                              : language === "vietnamese"
                              ? faq.answer_vietnamese
                              : language === "arabic"
                              ? faq.answer_arabic
                              : null,
                        }}
                      ></p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default FAQs;
